import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Typography,
  Box,
  Button,
  Paper
} from '@mui/material'
import ArticleIcon from '@mui/icons-material/Article'
import AddIcon from '@mui/icons-material/Add'
import ContentTable from '../components/tables/contentTable'

export default function ContentPage() {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        maxWidth: '1400px',
        mx: 'auto',
        px: 2,
        py: 2,
      }}
    >
      {/* Header */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <ArticleIcon fontSize="large" sx={{ color: '#1976d2' }} />
          <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
            Content Management
          </Typography>
        </Box>
        
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/content/create')}
          sx={{
            backgroundColor: '#1976d2',
            '&:hover': {
              backgroundColor: '#1565c0'
            }
          }}
        >
          Add Custom Content
        </Button>
      </Box>

      {/* Description */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="body1" color="text.secondary">
          Manage content items that define the display configuration for prompts, styles, and sections. 
          Each content item can have banners, videos, design types, and be associated with tags and entities.
        </Typography>
      </Box>

      {/* Content Table */}
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        <ContentTable />
      </Paper>
    </Box>
  )
}
